import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["NextAuthSessionProvider"] */ "/app/src/auth/session.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/analytics/ga-route-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/analytics/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppContextProvider"] */ "/app/src/contexts/app.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/providers/theme.tsx");
